import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { storeGet } from '../../crud/storage';

function AuthGuard({ children }) {
  const history = useHistory();
  const user = storeGet('user');
  const isLoggedIn = !!(user && user.token);

  useEffect(() => {
    if (!isLoggedIn) {
      history.replace('/login');
    }
  }, [isLoggedIn, history]);

  if (!isLoggedIn) return null;

  return children;
}

export default AuthGuard;
